import AccountProfile from "../components/accountProfile";

const AccountPage = () => {
    return (
        <div>
            <AccountProfile />
        </div>
    );
};

export default AccountPage;